// @ts-nocheck
import type * as React from 'react';

import * as styles from './styles';
import { SelectionControl } from './SelectionControl';
import styled from '@emotion/styled';
import MuiCheckbox, { type CheckboxProps as MuiCheckboxProps } from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';

import { CheckIcon, IndeterminateIcon } from '../icons';

import { colors } from '../styles/colors';
import { CaptionError } from '../typography/Caption/Caption';

interface CheckboxProps extends MuiCheckboxProps {
  label?: React.ReactNode;
  title?: string;
  ellipsis?: boolean;
  errorMessage?: string;
}

interface BoxProps {
  disabled?: boolean;
}

const Box = styled('div')`
  width: 18px;
  height: 18px;
  min-width: 18px;
  border-radius: 2px;
  border: solid 1px ${colors.gray.default};
  background-color: ${(props: BoxProps) => (props.disabled ? colors.gray.lightest : colors.white)};
  box-sizing: border-box;
`;

const BoxChecked = styled<BoxProps>(Box)`
  color: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${(props: BoxProps) => (props.disabled ? 'none' : '1px')};
  border: none;
  background-color: ${(props: BoxProps) => (props.disabled ? colors.gray.default : colors.success.default)};
`;

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const BaseCheckbox = withStyles({
  root: {
    padding: 0,
    width: '18px',
    height: '18px',
    color: colors.gray.default,
  },
  checked: {
    '&&': {
      color: colors.white,
    },
  },
})((props: MuiCheckboxProps) => (
  <MuiCheckbox
    icon={<Box disabled={props.disabled} />}
    checkedIcon={
      <BoxChecked checked={props.checked} disabled={props.disabled}>
        <CheckIcon />
      </BoxChecked>
    }
    indeterminateIcon={
      <BoxChecked disabled>
        <IndeterminateIcon />
      </BoxChecked>
    }
    {...props}
  />
));

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const Checkbox = (props: CheckboxProps) => {
  const { label, className, errorMessage, title, ellipsis, ...otherProps } = props;
  return (
    <div className={styles.checkboxWrapper}>
      <SelectionControl className={className} ellipsis={ellipsis} title={title} label={label} control={<BaseCheckbox {...otherProps} />} />
      {errorMessage && <CaptionError>{errorMessage}</CaptionError>}
    </div>
  );
};
